export const applyPercentage = (number, percentage) => {
    return number + (number * percentage / 100);
}
